import sentGAEvent from ".";

/**
 * profile 页面出现
 */
const GAPersonalProfilePageDisplay = () => {
  sentGAEvent({
    category: "profile",
    action: "profile_display",
  });
};

/**
 * history 页面出现
 */
const GAPersonalHistoryPageDisplay = label => {
  sentGAEvent({
    category: "history",
    action: "history_display",
    label,
  });
};

/**
 * setting 页面出现
 */
const GAPersonalSettingPageDisplay = () => {
  sentGAEvent({
    category: "setting",
    action: "setting_display",
  });
};

/**
 * promotion 页面出现
 */
const GAPersonalPromotionPageDisplay = () => {
  sentGAEvent({
    category: "promotion",
    action: "promotion_display",
  });
};

/**
 * history 页面 go to edit 按钮点击
 */
const GAPersonalHistoryToEditClick = () => {
  sentGAEvent({
    category: "hirtory",
    action: "history_edit_click",
  });
};

/**
 * 点击change password 按钮
 */
const GAPersonalChangePasswordBtnClick = () => {
  sentGAEvent({
    category: "change_password",
    action: "change_password_click",
  });
};

/**
 * change password 表单格式错误
 */
const GAPersonalChangePasswordFormError = label => {
  sentGAEvent({
    category: "change_password",
    action: "change_password_error",
    label,
  });
};

/**
 * change password 提交按钮点击
 */
const GAPersonalChangePasswordConfirm = () => {
  sentGAEvent({
    category: "change_password",
    action: "change_confirm_click",
  });
};

/**
 * change password 成功
 */
const GAPersonalChangePasswordSuccess = () => {
  sentGAEvent({
    category: "change_password",
    action: "change_success_display",
  });
};

/**
 * feedback 提交按钮点击
 */
const GAPersonalFeedbackBtnClick = () => {
  sentGAEvent({
    category: "feedback",
    action: "feedback_submit_click",
  });
};

/**
 * feedback 提交成功或者失败
 * @param {string} label
 */
const GAPersonalFeedbackConfirmStatus = label => {
  sentGAEvent({
    category: "feedback",
    action: "feedback_submit_click",
    label,
  });
};

/**
 * appearance 点击change appearance 按钮
 */
const GAPersonalChangeAppearanceClick = () => {
  sentGAEvent({
    category: "appearance",
    action: "change_display_click",
  });
};

/**
 * appearance 提交
 * @param {string} label
 */
const GAPersonalChangeAppearanceConfirm = label => {
  sentGAEvent({
    category: "appearance",
    action: "confirm_display_click",
    label,
  });
};

/**
 * premium Profile页面跳转到购买
 */
const GAPersonalProfileLinkToPremium = () => {
  sentGAEvent({
    category: "premium",
    action: "premium_profile",
  });
};

/**
 * premium 侧边banner跳转到购买
 */
const GAPersonalBannerLinkToPremium = () => {
  sentGAEvent({
    category: "premium",
    action: "premium_banner",
  });
};

/**
 * premium 侧边History跳转到购买
 */
const GAPersonalHistoryLinkToPremium = () => {
  sentGAEvent({
    category: "premium",
    action: "premium_history",
  });
};

export {
  GAPersonalProfilePageDisplay,
  GAPersonalHistoryPageDisplay,
  GAPersonalSettingPageDisplay,
  GAPersonalPromotionPageDisplay,
  GAPersonalHistoryToEditClick,
  GAPersonalChangePasswordBtnClick,
  GAPersonalChangePasswordFormError,
  GAPersonalChangePasswordConfirm,
  GAPersonalChangePasswordSuccess,
  GAPersonalFeedbackBtnClick,
  GAPersonalFeedbackConfirmStatus,
  GAPersonalChangeAppearanceClick,
  GAPersonalChangeAppearanceConfirm,
  GAPersonalProfileLinkToPremium,
  GAPersonalBannerLinkToPremium,
  GAPersonalHistoryLinkToPremium,
};
